import { useRouter } from "next/router"

const STEPS = [
  {
    route: "/",
  },
  {
    route: "/cars",
  },
  {
    route: "/order/details",
  },
  {
    route: "order/summary",
  },
]

const STEPS_WITHOUT_DISTANCE = [
  {
    route: "/cars",
  },
  {
    route: "/order/location",
  },
  {
    route: "/order/details",
  },
  {
    route: "order/summary",
  },
]

export const useSteps = () => {
  const router = useRouter()
  const query = new URLSearchParams(
    router.query as Record<string, string>
  ).toString()

  const steps = Boolean(router.query.from_place_id)
    ? STEPS
    : STEPS_WITHOUT_DISTANCE

  return {
    query,
    steps,
  }
}
